import ResponsivePopover from './ResponsivePopover'

export type { ResponsivePopoverProps } from './ResponsivePopover'
export default ResponsivePopover
